/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RetailerNotificationMessage,
} from '../models/index';
import {
    RetailerNotificationMessageFromJSON,
    RetailerNotificationMessageToJSON,
} from '../models/index';

export interface GetNotificationsOnDisplayRequest {
    langCode: string;
}

export interface MarkRetailerNotificationAsReadRequest {
    notificationId: number;
}

/**
 * 
 */
export class RetailerNotificationResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getNotificationsOnDisplay without sending the request
     */
    async getNotificationsOnDisplayRequestOpts(requestParameters: GetNotificationsOnDisplayRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['langCode'] == null) {
            throw new runtime.RequiredError(
                'langCode',
                'Required parameter "langCode" was null or undefined when calling getNotificationsOnDisplay().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/notification/{langCode}`;
        urlPath = urlPath.replace(`{${"langCode"}}`, encodeURIComponent(String(requestParameters['langCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getNotificationsOnDisplayRaw(requestParameters: GetNotificationsOnDisplayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RetailerNotificationMessage>>> {
        const requestOptions = await this.getNotificationsOnDisplayRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RetailerNotificationMessageFromJSON));
    }

    /**
     */
    async getNotificationsOnDisplay(requestParameters: GetNotificationsOnDisplayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RetailerNotificationMessage>> {
        const response = await this.getNotificationsOnDisplayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for markRetailerNotificationAsRead without sending the request
     */
    async markRetailerNotificationAsReadRequestOpts(requestParameters: MarkRetailerNotificationAsReadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['notificationId'] == null) {
            throw new runtime.RequiredError(
                'notificationId',
                'Required parameter "notificationId" was null or undefined when calling markRetailerNotificationAsRead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/notification/{notificationId}/read`;
        urlPath = urlPath.replace(`{${"notificationId"}}`, encodeURIComponent(String(requestParameters['notificationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async markRetailerNotificationAsReadRaw(requestParameters: MarkRetailerNotificationAsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const requestOptions = await this.markRetailerNotificationAsReadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async markRetailerNotificationAsRead(requestParameters: MarkRetailerNotificationAsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.markRetailerNotificationAsReadRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
